import React, { useContext, useEffect } from 'react';
import styled from 'styled-components/macro';
import HtmlParser from 'html-react-parser';

import { palette, fontDefaultAlt, RotationSpinner } from '@mirinae/react-ui';
import { UserContext } from '@mirinae/react-auth';

import LessonsContext from '@mirinae/lessons/modules/contexts/lessons';
import LessonCardList from '@mirinae/lessons/components/card/LessonCardList';
import ContentTop from '@mirinae/lessons/components/lesson/ContentTop';

const SubTitle = styled.div`
    margin-bottom: 5px;
    font-size: 40px;
    font-weight: 600;
    text-transform: capitalize;
    span {
        color: ${palette.green.middle};
    }
`;
const ComponentSize = styled.div`
    margin: 20px 0 30px;
    font-size: 20px;
    color: #94D0CD;
`;
const LabelTitle = styled.div`
    height: 22px;
    margin-bottom: 20px;
    color: ${palette.point.black};
    font-size: 18px;
    font-weight: 600;
    strong {
        color: ${palette.green.middle};
        font-weight: 700;
        font-family: ${fontDefaultAlt};
    }
`;
const ListGroup = styled.div`
    // margin-bottom: 30px;
`;
export const EmptyList = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
`;

const GroupComponents = ({ group, title, linkPlayer, onBack }) => {
    const lessons = useContext(LessonsContext);
    const [userContext] = useContext(UserContext);
    const activeLessons = lessons.activeLessons.filter(l => (group === 'active' ? l : l.lessonNode.group.toLowerCase() === group.toLowerCase()));
    const lessonsToStart = lessons.lessonsToStart.filter(l => l.lessonNode.group.toLowerCase() === group.toLowerCase());
    const completedLessons = lessons.completedLessons.filter(l => l); // (group === 'complete' ? l : l.lessonNode.group.toLowerCase() === group.toLowerCase()));

    useEffect(() => {
        document.body.classList.add(`lesson-${group}`);
        return (() => {
            document.body.classList.remove(`lesson-${group}`);
        });
    });

    useEffect(() => {
        if (userContext.user && userContext.user.name)
            lessons.loadLessonLists();
    }, [userContext.user]);

    const numberOrder = (l) => (l.lessonNode.number || 1000) + (l.lessonNode.backupForNodeID || l.lessonNode.status === 'Backup' ? 1000 : 0);
    const numberSort = (l1, l2) => numberOrder(l1) - numberOrder(l2);

    return (
        <>
            <ContentTop onBack={onBack} />
            <SubTitle>{HtmlParser(title.match(/active|complete/i) ? `<span>${title === 'complete' ? 'completed' : title}</span> Lessons` : title)}</SubTitle>
            { lessons.initializing ? (
                <EmptyList><RotationSpinner /></EmptyList>
            ) : (
                <>
                    { group.match(/active|complete/i) ? <ComponentSize>{activeLessons.length} Active lessons</ComponentSize>
                        : <ComponentSize>{lessons.lessonTable[group] !== undefined ? lessons.lessonTable[group].count : '0'} Active lessons</ComponentSize>}
                    { activeLessons.length > 0 && (
                        <ListGroup>
                            {group !== 'active' && <LabelTitle><strong>Active</strong> lessons</LabelTitle>}
                            <LessonCardList lessons={activeLessons} playerPath={linkPlayer} />
                        </ListGroup>
                    )}
                    { lessonsToStart.length > 0 && (
                        <ListGroup>
                            <LabelTitle><strong>Lessons</strong></LabelTitle>
                            <LessonCardList lessons={lessonsToStart.sort(numberSort)} playerPath={linkPlayer} />
                        </ListGroup>
                    )}
                    { completedLessons.length > 0 && (
                        <ListGroup style={{ marginTop: 30 }}>
                            {group !== 'complete' && <LabelTitle><strong>Completed</strong> lessons</LabelTitle>}
                            <LessonCardList lessons={completedLessons} playerPath={linkPlayer} />
                        </ListGroup>
                    )}
                </>
            )}
        </>
    );
};

export default GroupComponents;